import { List } from '@store/abstract/List';
import { OptionalAsNullable } from 'chaika-common-types';

export class SimpleList<T, F = null, I = string> extends List<T, T, F, I> {
    public update(id: I, updateParams: Partial<OptionalAsNullable<T>>): void {
        const current = this.get(id);
        if (!current) {
            return;
        }

        super.update(id, { ...current, ...updateParams });
    }

    protected create(params: T): T {
        return params;
    }
}
